import React from 'react'

import MenuSection from '../MenuSection'
import UserSearch from '../UserSearch'

import { OWNER_OPTIONS, TASKS_OTHER_OWNER } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'

type OwnerFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const OwnerFilter: React.FC<OwnerFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()
  const { user } = useEnvironment()

  return (
    <MenuSection
      title='Task owner'
      options={OWNER_OPTIONS}
      value={state.ownerValue}
      setValue={handleChange('ownerValue')}
      unassignedOpt='Any owner'
      {...props}
    >
      {state.ownerValue === TASKS_OTHER_OWNER && (
        <UserSearch
          userID={user?.id}
          value={state.ownerID}
          setValue={handleChange('ownerID')}
          startOpen
        />
      )}
    </MenuSection>
  )
}

export default OwnerFilter
